<template>
  <div>
    <div
      class="gdlr-core-pbf-wrapper hp1-col-services"
      data-skin="Blue Title"
      id="gdlr-core-wrapper-1"
      style="height: 110px;"
    >
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full-no-space"
        >
          <div
            class="gdlr-core-pbf-wrapper-container-inner gdlr-core-item-mglr clearfix"
            id="div_1dd7_0"
          >
            <div
              class="gdlr-core-pbf-column gdlr-core-column-15 gdlr-core-column-first"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="100"
            >
              <div
                class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                id="div_1dd7_1"
              >
                <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div class="gdlr-core-pbf-element">
                    <router-link :to="`/galeri`" target="_self">
                      <div
                        class="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                        id="div_1dd7_2"
                      >
                        <div
                          class="gdlr-core-column-service-media gdlr-core-media-image"
                        >
                          <img
                            :src="
                              require('@/assets/images/template4/icon-1.png')
                            "
                            alt=""
                            width="40"
                            height="40"
                            title="icon-1"
                          />
                        </div>
                        <div class="gdlr-core-column-service-content-wrapper">
                          <div class="gdlr-core-column-service-title-wrap">
                            <h3
                              class="gdlr-core-column-service-title gdlr-core-skin-title"
                              id="h3_1dd7_0"
                            >
                              Galeri
                            </h3>
                            <div
                              class="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                              id="div_1dd7_3"
                            >
                              Semua ada disini
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-aos="zoom-in"
              data-aos-duration="2000"
              data-aos-delay="200"
              class="gdlr-core-pbf-column gdlr-core-column-15"
              id="gdlr-core-column-1"
            >
              <div
                class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                id="div_1dd7_4"
              >
                <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div class="gdlr-core-pbf-element">
                    <div
                      class="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_5"
                    >
                      <div
                        class="gdlr-core-column-service-media gdlr-core-media-image"
                      >
                        <img
                          :src="require('@/assets/images/template4/icon-2.png')"
                          alt=""
                          width="44"
                          height="40"
                          title="icon-2"
                        />
                      </div>
                      <div class="gdlr-core-column-service-content-wrapper">
                        <div class="gdlr-core-column-service-title-wrap">
                          <h3
                            class="gdlr-core-column-service-title gdlr-core-skin-title"
                            id="h3_1dd7_1"
                          >
                            Kewirausahaan
                          </h3>
                          <div
                            class="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_6"
                          >
                            Wirausaha Sekolah
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-aos="zoom-in"
              data-aos-duration="3000"
              data-aos-delay="300"
              class="gdlr-core-pbf-column gdlr-core-column-15"
              id="gdlr-core-column-2"
            >
              <div
                class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                id="div_1dd7_7"
              >
                <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div class="gdlr-core-pbf-element">
                    <div
                      class="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_8"
                    >
                      <div
                        class="gdlr-core-column-service-media gdlr-core-media-image"
                      >
                        <img
                          :src="require('@/assets/images/template4/icon-3.png')"
                          alt=""
                          width="44"
                          height="39"
                          title="icon-3"
                        />
                      </div>
                      <div class="gdlr-core-column-service-content-wrapper">
                        <div class="gdlr-core-column-service-title-wrap">
                          <h3
                            class="gdlr-core-column-service-title gdlr-core-skin-title"
                            id="h3_1dd7_2"
                          >
                            E-Learning
                          </h3>
                          <div
                            class="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_9"
                          >
                            Pembelajaran
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="gdlr-core-pbf-column gdlr-core-column-15"
              id="gdlr-core-column-3"
              data-aos="zoom-in"
              data-aos-duration="3000"
              data-aos-delay="300"
            >
              <div
                class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                id="div_1dd7_10"
              >
                <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div class="gdlr-core-pbf-element">
                    <div
                      class="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                      id="div_1dd7_11"
                    >
                      <div
                        class="gdlr-core-column-service-media gdlr-core-media-image"
                      >
                        <img
                          :src="require('@/assets/images/template4/icon-4.png')"
                          alt=""
                          width="41"
                          height="41"
                          title="icon-4"
                        />
                      </div>
                      <div class="gdlr-core-column-service-content-wrapper">
                        <div class="gdlr-core-column-service-title-wrap">
                          <h3
                            class="gdlr-core-column-service-title gdlr-core-skin-title"
                            id="h3_1dd7_3"
                          >
                            Pembayaran
                          </h3>
                          <div
                            class="gdlr-core-column-service-caption gdlr-core-info-font gdlr-core-skin-caption"
                            id="div_1dd7_12"
                          >
                            Pembayaran
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
